import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const isScrollLockedRoute = (pathname) => {
  if (!pathname) return false;
  if (pathname === "/app" || pathname === "/app/home" || pathname === "/app/board") {
    return true;
  }
  if (pathname.startsWith("/c/")) {
    return true;
  }
  return false;
};

const RouteScrollModeManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const locked = isScrollLockedRoute(pathname);
    document.body.classList.toggle("route-scroll-locked", locked);
    document.body.classList.toggle("route-scroll-unlocked", !locked);
  }, [pathname]);

  return null;
};

export default RouteScrollModeManager;
